import { render, staticRenderFns } from "./organization-question-set-detail.vue?vue&type=template&id=cfde4224&scoped=true&"
import script from "./organization-question-set-detail.vue?vue&type=script&lang=js&"
export * from "./organization-question-set-detail.vue?vue&type=script&lang=js&"
import style0 from "./organization-question-set-detail.vue?vue&type=style&index=0&id=cfde4224&lang=scss&scoped=true&"
import style1 from "./organization-question-set-detail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfde4224",
  null
  
)

export default component.exports